import EmblaCarousel from 'embla-carousel'
import AutoScroll from 'embla-carousel-auto-scroll'

window.addEventListener('load', function() {
    const emblaNodes = document.querySelectorAll('.embla')
    
    emblaNodes.forEach(emblaNode => {
        const viewportNode = emblaNode.querySelector('.embla__viewport')
        
        const options = { 
            loop: true,
            dragFree: true,
            align: 'start',
        }
        
        const emblaApi = EmblaCarousel(viewportNode, options, [
            AutoScroll({ 
                playOnInit: true,
                speed: emblaNode.dataset.scrollSpeed,
                stopOnInteraction: false,
                stopOnMouseEnter: false
            })
        ])
    })
})